import { bootstrapApplication } from '@angular/platform-browser'
import { appConfig } from './app/app.config'
import { AppComponent } from './app/app.component'
import { Amplify } from 'aws-amplify'
import { CookieStorage } from 'aws-amplify/utils'
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito'
import { bucketName, cognitoProxy, identityPoolId, mainDomain, poolId, poolWebClientId, ssoSameSite, ssoSecure } from './app/common/utilities/constants'
import '@angular/localize/init'

type SameSite = 'lax' | 'strict' | 'none'

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolEndpoint: cognitoProxy,
      userPoolId: poolId,
      userPoolClientId: poolWebClientId,
      identityPoolId
    }
  },
  Storage: {
    S3: {
      bucket: bucketName,
      region: 'ap-southeast-1'
    }
  }
})
const cookieStorage = new CookieStorage({
  domain: mainDomain,
  path: '/',
  secure: ssoSecure,
  sameSite: ssoSameSite as SameSite | undefined
})

cognitoUserPoolsTokenProvider.setKeyValueStorage(cookieStorage)

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err))
